export default "__VITE_ASSET__riKpSbG0__"